/* Cart -> RFQ auto-loader for BuyDirect & Save.
   When the RFQ page is opened from the cart (?source=cart), this reads the
   live cart via /cart.js and pre-fills every line item into the quote form,
   reusing the form's own product lookup so items lock with real price + SKU.
   Small, self-contained, and does NOT modify assets/rfq-form.js. */
(function(){
  var P = new URLSearchParams(location.search);
  if (P.get("source") !== "cart") return;
  function q(s,el){ return (el||document).querySelector(s); }
  function setInput(sel,val){ var f=q(sel); if(f){ f.value=val; f.dispatchEvent(new Event("input",{bubbles:true})); } }
  function ready(cb){
    var n=0, iv=setInterval(function(){
      n++;
      if (q("#itemRows") && q("#addItem")) { clearInterval(iv); cb(); }
      else if (n>200) { clearInterval(iv); }
    }, 50);
  }
  ready(function(){
    fetch("/cart.js", {headers:{Accept:"application/json"}})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        if (!cart || !cart.items || !cart.items.length) return;
        var items = cart.items;
        var addBtn = q("#addItem");
        for (var k=1; k<items.length; k++) { addBtn.click(); }
        items.forEach(function(li,i){
          var url=(li.url||"").split("?")[0];
          var box=q('.rfq-sr[data-results="'+i+'"]');
          if (box && url){
            var b=document.createElement("button");
            b.type="button"; b.className="rfq-sr-item";
            b.setAttribute("data-pick", i);
            b.setAttribute("data-url", url);
            box.appendChild(b);
            b.click();
          } else {
            setInput('input[data-name="'+i+'"]', li.product_title||li.title||"");
            setInput('input[data-sku="'+i+'"]', li.sku||"");
          }
        });
        var passes=0;
        var qiv=setInterval(function(){
          passes++;
          var done=true;
          items.forEach(function(li,i){
            var qi=q('input[data-qty="'+i+'"]');
            var inc=q('button[data-inc="'+i+'"]');
            if (qi && inc){
              var cur=parseInt(qi.value,10)||1;
              if (cur < li.quantity){ inc.click(); done=false; }
            } else { done=false; }
          });
          if (done || passes>80) clearInterval(qiv);
        }, 120);
        setTimeout(function(){ Array.prototype.forEach.call(document.querySelectorAll(".rfq-sr"), function(x){ x.innerHTML=""; }); }, 1400);
      })
      .catch(function(){});
  });
})();